import AdminLayout from "@/layouts/AdminLayout.vue";
export const AdminRoutes = {
    path: "/admin",
    component: AdminLayout,
    meta: {
        middleware: "auth",
        requiresAuth: true,
        role: 'Superadmin'
    },
    children: [
        {
            path: '',
            component: () => import("@/pages/admin/Statistic/StatisticPage.vue"),
            name: "admin",
            meta: {
                title: "Painel de Controle - ACASA"
            }
        },

        {
            path: 'dashboard',
            component: () => import("@/pages/admin/Statistic/StatisticPage.vue"),
            name: "admin.dashboard",
            meta: {
                title: "Painel de Controle - ACASA"
            }
        },
        {
            path: 'profile',
            name: 'admin.profile',
            component: () => import("@/pages/admin/profile/MyProfile.vue"),
            // component: () => import("@/components/mainProfile.vue"),
            requiresAuth: true,
            meta: {
                title: "Perfil - ACASA"
            },
        },

        {
            path: 'profile',
            name: 'admin.profile-list',
            component: () => import("@/pages/admin/profile/ListProducts.vue"),
            meta: {
                title: 'Produtos - ACASA'
            }
        },
        {
            path: 'add-product',
            name: 'admin.add-product',
            component: () => import("@/pages/admin/profile/addProducts.vue"),
            mata: {
                title: 'Adicionar Produtos - ACASA'
            }
        },
        {
            path: 'update-product/:id',
            component: () => import("@/pages/admin/profile/EditProduct.vue"),
            name: 'admin.update-my-product',
            meta: {
                title: 'Atualizar Produto - ACASA'

            }
        },
        {
            path: "myData",
            name: 'admin.my-data',
            component: () => import("@/pages/admin/profile/MyProfile.vue"),
            meta: {
                title: 'Perfil - ACASA'
            }
        },
        {
            path: 'edit-profile',
            name: 'admin.edit-profile',
            component: () => import("@/pages/admin/profile/EditProfile.vue"),
            meta: {
                title: 'Editar Perfil - ACASA'
            }
        },
        {
            path: 'update_password',
            component: () => import("@/pages/auth/UpdatePasswordPage.vue"),
            meta: {
                title: 'Atualizar Senha - ACASA'
            }
        },

        {
            path: 'adminProfile',
            name: 'admin.admin-profile',
            component: () => import("@/pages/admin/profile/MyProfile.vue"),
            meta: {
                title: 'Perfil - ACASA'
            }
        },
        {
            path: 'update_credetials',
            name: 'admin.update-credentials',
            component: () => import("@/pages/auth/UpdatePasswordPage.vue"),
            meta: {
                title: 'Atualizar Credenciais - ACASA'
            }
        },

        {
            path: 'edit-admin-profile',
            name: 'admin.edit-admin-profile',
            component: () => import("@/pages/admin/profile/EditProfile.vue"),
            meta: {
                title: 'Editar Perfil - ACASA'
            }
        },
        {
            path: 'add-products',
            name: 'admin.add-products',
            component: () => import("@/pages/admin/Products/addProducts.vue"),
            meta: {
                title: "Adicionar Produtos - ACASA"
            }
        },
        {
            path: 'list-products',
            name: 'admin.list-products',
            component: () => import("@/pages/admin/Products/ListProducts.vue"),
            meta: {
                title: 'Listar Produtos - ACASA'
            }
        },
        {
            path: 'list-contacts',
            name: 'admin.list-contacts',
            component: () => import("@/pages/admin/contacts/ListContact.vue"),
            meta: {
                title: 'Listar Contatos - ACASA'
            }
        },
        {
            path: 'list-actions-log',
            name: 'admin.list-actions-log',
            component: () => import("@/pages/admin/actions-log/ListActionLog.vue"),
            meta: {
                title: 'Listar Ações - ACASA'
            }
        },
        {
            path: "list-available-products",
            name: "admin.list-available-products",
            component: () => import("@/pages/admin/Products/ListProductsAvailable.vue"),
            meta: {
                title: 'Listar Produtos Disponíveis - ACASA'
            }
        },
        {
            path: 'edit-porduct/:query',
            name: 'admin.edit-product',
            component: () => import("@/pages/admin/Products/EditProduct.vue"),
            meta: {
                title: 'Editar Produto - ACASA'
            }
        },
        {
            path: 'add-agents',
            name: 'admin.add-agents',
            component: () => import("@/pages/admin/Agents/AgentsForm.vue"),
            meta: {
                title: 'Adicionar Agentes - ACASA'
            }

        },
        {
            path: 'list-agents',
            name: 'admin.list-agents',
            component: () => import("@/pages/admin/Agents/ListAgents.vue"),
            meta: {
                title: 'Listar Agentes - ACASA'
            }
        },
        {
            path: 'edit-agent/:id',
            name: 'admin.edit-agent',
            component: () => import("@/pages/admin/Agents/EditAgent.vue"),
            meta: {
                title: "Editar Agente - ACASA"
            }
        },

        {
            path: 'view-agent/:id',
            name: 'admin.view-agent',
            component: () => import("@/pages/admin/Agents/ViewAgent.vue"),
            meta: {
                title: "Visualizar Agente - ACASA"
            }
        },

        {
            path: 'add-proporsal',
            name: "admin.add-proposal",
            component: () => import("@/pages/admin/Proporsal/ProporsalPage.vue"),
            meta: {
                title: "Adicionar Proposta - ACASA"
            }
        },
        {
            path: 'list-proporsal',
            name: "admin.list-proporsal",
            component: () => import("@/pages/admin/Proporsal/ListProporsal.vue"),
            meta: {
                title: "Listar Propostas - ACASA"
            }
        },
        {
            path: 'update-proporsal/:id',
            name: "admin.edit-proporsal",
            component: () => import("@/pages/admin/Proporsal/EditProporsal.vue"),
            meta: {
                title: "Atualizar Proposta - ACASA"
            }

        },
        {
            path: 'view-proporsal/:id',
            name: "admin.view-proposal",
            component: () => import("@/pages/admin/Proporsal/ViewProporsal.vue"),
            meta: {
                title: "Visualizar Proposta - ACASA"
            }

        },
        {
            path: 'show-product-proporsal/:id',
            name: "admin.show-product-proposal",
            component: () => import("@/pages/admin/Proporsal/product_proporsal.vue"),
            meta: {
                title: "Propostas do Produto - ACASA"
            }

        },

        {
            path: 'list-be-agent',
            name: "admin.list-be-agent",
            component: () => import("@/pages/admin/Agents/ListBeAgent.vue"),
            meta: {
                title: "Quero ser Agente - ACASA"
            }

        },

        {
            path: 'list-candidate',
            name: "admin.list-candidate",
            component: () => import("@/pages/admin/Agents/ListFranchise.vue"),
            meta: {
                title: "Listar Franquias - ACASA"
            }

        },
        {
            path: 'payment-reports',
            name: "admin.payment-reports",
            component: () => import("@/pages/admin/Payments/PaymentReports.vue"),
            meta: {
                title: "Pagamentos - ACASA"
            }

        },
        {
            path: 'users',
            name: "admin.users",
            component: () => import("@/pages/admin/Users/ListUsers.vue"),
            meta: {
                title: "Utilizadores - ACASA"
            }

        },
        {
            path: 'users-edit/:id',
            name: "admin.users-edit",
            component: () => import("@/pages/admin/Users/EditUser.vue"),
            meta: {
                title: "Utilizadores - ACASA"
            }

        }

    ]


};